var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-spinner",class:_vm.size},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }